import * as React from "react";

const Svg45 = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 38"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_7378_13588"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        y="24"
        width="24"
        height="24"
        transform="rotate(-90 0 24)"
        fill="currentColor"
      />
    </mask>
    <g mask="url(#mask0_7378_13588)">
      <path
        d="M20 19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H6C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19L4 5C4 4.45 4.19583 3.97917 4.5875 3.5875C4.97917 3.19583 5.45 3 6 3H18C18.55 3 19.0208 3.19583 19.4125 3.5875C19.8042 3.97917 20 4.45 20 5V19ZM18 19V5H6L6 19H18Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M9.40332 33.5205H8.54395V35H7.06934V33.5205H4.02246V32.4707L7.15234 27.8613H8.54395V32.3486H9.40332V33.5205ZM7.06934 32.3486V31.1377C7.06934 31.0238 7.07096 30.8887 7.07422 30.7324C7.08073 30.5762 7.08724 30.4199 7.09375 30.2637C7.10026 30.1074 7.10677 29.9691 7.11328 29.8486C7.12305 29.7249 7.12956 29.6387 7.13281 29.5898H7.09375C7.0319 29.7233 6.9668 29.8535 6.89844 29.9805C6.83008 30.1042 6.75033 30.2344 6.65918 30.3711L5.35059 32.3486H7.06934ZM11.1455 34.3018C11.1455 33.9958 11.2285 33.7809 11.3945 33.6572C11.5638 33.5335 11.7673 33.4717 12.0049 33.4717C12.236 33.4717 12.4346 33.5335 12.6006 33.6572C12.7699 33.7809 12.8545 33.9958 12.8545 34.3018C12.8545 34.5947 12.7699 34.8063 12.6006 34.9365C12.4346 35.0667 12.236 35.1318 12.0049 35.1318C11.7673 35.1318 11.5638 35.0667 11.3945 34.9365C11.2285 34.8063 11.1455 34.5947 11.1455 34.3018ZM11.1455 30.2686C11.1455 29.9626 11.2285 29.7477 11.3945 29.624C11.5638 29.5003 11.7673 29.4385 12.0049 29.4385C12.236 29.4385 12.4346 29.5003 12.6006 29.624C12.7699 29.7477 12.8545 29.9626 12.8545 30.2686C12.8545 30.5648 12.7699 30.778 12.6006 30.9082C12.4346 31.0352 12.236 31.0986 12.0049 31.0986C11.7673 31.0986 11.5638 31.0352 11.3945 30.9082C11.2285 30.778 11.1455 30.5648 11.1455 30.2686ZM17.4238 30.4395C17.86 30.4395 18.2474 30.5225 18.5859 30.6885C18.9277 30.8545 19.1963 31.0986 19.3916 31.4209C19.5869 31.7432 19.6846 32.1403 19.6846 32.6123C19.6846 33.1266 19.5771 33.571 19.3623 33.9453C19.1507 34.3164 18.8333 34.6012 18.4102 34.7998C17.9902 34.9984 17.4661 35.0977 16.8379 35.0977C16.4635 35.0977 16.1104 35.0651 15.7783 35C15.4495 34.9382 15.1615 34.8421 14.9141 34.7119V33.4082C15.1615 33.5384 15.4577 33.6491 15.8027 33.7402C16.151 33.8281 16.4782 33.8721 16.7842 33.8721C17.0837 33.8721 17.3359 33.833 17.541 33.7549C17.7461 33.6735 17.9007 33.5498 18.0049 33.3838C18.1123 33.2145 18.166 32.9997 18.166 32.7393C18.166 32.391 18.0488 32.124 17.8145 31.9385C17.5801 31.7529 17.2204 31.6602 16.7354 31.6602C16.5498 31.6602 16.3561 31.6781 16.1543 31.7139C15.9557 31.7497 15.7897 31.7855 15.6562 31.8213L15.0557 31.499L15.3242 27.8613H19.1963V29.1406H16.6475L16.5156 30.542C16.6263 30.5192 16.7467 30.4964 16.877 30.4736C17.0072 30.4508 17.1895 30.4395 17.4238 30.4395Z"
      fill="currentColor"
    />
  </svg>
);
export default Svg45;
